import React from "react";

/**
 * InlineEditDiffView — unified diff display for the inline AI edit gate.
 * Accepts the array of line objects returned by `diffArtifacts()`.
 *
 * Line types:
 *   added     — green  (+)
 *   removed   — red    (-)
 *   unchanged — muted  ( )
 *   collapsed — pill   (↕ N unchanged lines) — represents a folded run
 */
export default function InlineEditDiffView({ lines }) {
  if (!lines || lines.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center text-xs text-ink-gray-500 dark:text-ink-gray-400">
        No changes
      </div>
    );
  }
  return (
    <div className="w-full h-full overflow-auto bg-fill-hex-0d1117 font-mono text-xs leading-5 p-4">
      {lines.map((line, i) => {
        if (line.type === "collapsed") {
          return (
            <div
              key={i}
              className="px-2 py-0.5 my-1 text-ink-canvas-accent/60 text-[10px] select-none"
            >
              {line.value}
            </div>
          );
        }
        return (
          <div
            key={i}
            className={`px-2 whitespace-pre-wrap break-all ${
              line.type === "added"
                ? "bg-fill-hex-0d2a1a text-ink-hex-3fb950"
                : line.type === "removed"
                ? "bg-fill-hex-2a0d0d text-ink-hex-f85149"
                : "text-ink-hex-8b9eb0"
            }`}
          >
            <span className="select-none mr-2 opacity-50">
              {line.type === "added" ? "+" : line.type === "removed" ? "-" : " "}
            </span>
            {line.value}
          </div>
        );
      })}
    </div>
  );
}
